import FupExerciseSettingListPagingResultModelBase from '../_generated/modelBases/fup-exercise-setting-list-paging-result-model-base';

export default class FupExerciseSettingListPagingResultModel extends FupExerciseSettingListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
